<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row class="mb-1">
          <b-col
            cols="8"
            offset-md="2"
          >
            <h4>Filter</h4>
            <b-form class="needs-validation">
              <b-row>
                <b-col cols="6">
                  <b-form-group
                    label="Tahun"
                    label-for="tahunFilter"
                  >
                    <b-form-select
                      id="tahunFilter"
                      v-model="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Versi"
                    label-for="versiFilter"
                  >
                    <b-form-select
                      id="versiFilter"
                      v-model="versiFilter"
                      :options="dataVersi"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Wilayah"
                    label-for="wilayahFilter"
                  >
                    <b-form-select
                      id="wilayahFilter"
                      v-model="wilayahFilter"
                      :options="dataWilayah"
                      :disabled="!$can('Filter', 'laporan')"
                      @change="changeWilayah"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="KIB"
                    label-for="kibFilter"
                  >
                    <b-form-select
                      id="kibFilter"
                      v-model="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="PD/UPD"
                    label-for="pdUpdFilter"
                  >
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      :disabled="
                        !$can('Filter', 'laporan') &&
                          !$can('Filter-PdUpd', 'laporan')
                      "
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label="Jenis Laporan"
                    label-for="jenisLaporan"
                  >
                    <b-form-select
                      id="jenisLaporanFilter"
                      v-model="jenisLaporanFilter"
                      :options="dataJenisLaporanFilter"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-col>

          <b-col
            cols="12"
            class="mt-2"
          >
            <!-- table -->
            <b-row>
              <b-col
                cols="6"
                align="right"
              >
                <b-button
                  size="large"
                  class="mb-2"
                  variant="danger"
                  :disabled="!pdUpdFilterValue.value || !jenisLaporanFilter"
                  @click="clickPdf"
                >
                  <b-col
                    cols="12"
                    class="mb-1"
                  >
                    <b-icon
                      icon="file-earmark-text"
                      style="width: 100px; height: 100px"
                    />
                  </b-col>
                  <b-col cols="12">
                    Download PDF
                  </b-col>
                </b-button>
              </b-col>
              <b-col cols="6">
                <b-button
                  size="large"
                  class="mb-2"
                  variant="success"
                  :disabled="!pdUpdFilterValue.value || !jenisLaporanFilter"
                  @click="clickExcel"
                >
                  <b-col
                    cols="12"
                    class="mb-1"
                  >
                    <b-icon
                      icon="file-earmark-excel"
                      style="width: 100px; height: 100px"
                    />
                  </b-col>
                  <b-col cols="12">
                    Download Excel
                  </b-col>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <!-- <b-col cols="12" class="mt-2" align="center">
            <b-button
              size="large"
              class="mb-2 cols-6"
              variant="success"
              v-b-tooltip.hover
              title="Download Laporan"
              @click="downloadFile"
              :disabled="!pdUpdFilterValue.value || !jenisLaporanFilter"
            >
              <b-col cols="12">
                <b-icon icon="download" style="width: 100px; height: 100px">
                </b-icon>
              </b-col>
              <b-col cols="12"> Download Laporan </b-col>
            </b-button>
          </b-col> -->
        </b-row>
        <div
          id="showPdf"
          class="mb-2"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
  BIcon,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { generateYears, startYear } from '@/libs/helper'
import master from '@/composables/master'

const moment = require('moment')

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const year = moment().format('YYYY')

    const isLoadingUpload = ref(false)

    const tahunFilter = ref($route.query.tahun || year)
    const versiFilter = ref($route.query.versi || 'Transitoris')
    const pdUpdFilter = ref($route.query['pd-upd'] || '')
    const pdUpdFilterValue = ref({
      text: pdUpdFilter.value || '-- Pilih Salah Satu --',
      value: pdUpdFilter.value || '',
    })
    const wilayahFilter = ref($route.query.wilayah || '')
    const kibFilter = ref($route.query.kib || 'C')
    const ukuranFilter = ref($route.query.ukuran || 1)
    const jenisLaporanFilter = ref(null)

    const filePdf = ref(null)

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))

    if (cookiesJenisAkun.value == 'D' || cookiesJenisAkun.value == 'F') {
      const cookiesNalok = ref(g.$cookies.get('nalok'))
      const cookiesKolok = ref(g.$cookies.get('kolok'))
      const cookiesWilayah = ref(g.$cookies.get('wilayah'))
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      }
      pdUpdFilter.value = cookiesKolok.value
      wilayahFilter.value = cookiesWilayah.value
    } else if (cookiesJenisAkun.value == 'pelaksana-suban') { wilayahFilter.value = parseInt(g.$cookies.get('wilayah'), 10) }

    const dataTahun = ref(generateYears(startYear, year))
    const dataWilayah = ref([{ text: '-- Semua --', value: '' }])
    const dataPdUpd = ref([{ text: '-- Pilih Salah Satu --', value: '' }])
    const dataProvinsi = ref([])
    const dataKecamatan = ref([])
    const dataKelurahan = ref([])
    const dataKib = ref([{ text: '-- Semua --', value: '' }])
    const dataUkuran = ref([
      { text: '6.5 x 10', value: 1 },
      { text: '15 x 10', value: 2 },
    ])
    const dataVersi = ref([{ value: 'Transitoris', text: 'Transitoris' }])
    const dataJenisLaporanFilter = ref([
      { text: '-- Pilih Salah Satu --', value: null },
      {
        text: 'Rekapitulasi Keberadaan BMD',
        value: 'keberadaan-bmd',
      },
      {
        text: 'Rekapitulasi BMD Berupa Biaya Perolehan',
        value: 'bmd-berupa-biaya-belum-diatribusi',
      },
      {
        text: 'Rekapitulasi BMD Berupa Biaya Setelah Perolehan',
        value: 'bmd-berupa-biaya-belum-dikapitalisasi',
      },
      {
        text: 'Rekapitulasi BMD Beban Lainnya',
        value: 'beban-yang-belum-direklasifikasi',
      },
      {
        text: 'Rekapitulasi BMD Bukan Biaya (Fisik) Yang Tidak Ditemukan',
        value: 'bmd-bukan-biaya-fisik-yang-tidak-ditemukan',
      },
      // {
      //   text: 'Rekapitulasi BMD Bukan Biaya (Fisik) Yang Akan Digabung',
      //   value: 'bmd-bukan-biaya-fisik-yang-akan-digabung',
      // },
      {
        text: 'Rekapitulasi Perubahan Kondisi BMD',
        value: 'perubahan-kondisi-bmd',
      },
      {
        text: 'Rekapitulasi BMD Dengan Kode Barang Yang Tidak Sesuai dengan Data Lama',
        value: 'bmd-dengan-kodefikasi',
      },
      {
        text: 'Rekapitulasi BMD Dengan Ukuran Yang Tidak Sesuai Dengan Data Lama',
        value: 'bmd-dengan-ukuran-yang-tidak-sesuai-dengan-data-lama',
      },
      {
        text: 'Rekapitulasi BMD Gedung Dan Bangunan Berdiri Di Atas Tanah Milik',
        value: 'bmd-gedung-dan-bangunan-berdiri-di-atas-tanah-milik',
      },
      {
        text: 'Rekapitulasi BMD Terindikasi Tercatat Ganda',
        value: 'bmd-terindikasi-tercatat-ganda',
      },
      {
        text: 'Rekapitulasi BMD Terindikasi Tercatat Gelondongan',
        value: 'bmd-terindikasi-tercatat-gelondongan',
      },
      {
        text: 'Rekapitulasi BMD Yang Tidak Memiliki SK Penggunaan',
        value: 'bmd-yang-tidak-memiliki-sk-penggunaan',
      },
      {
        text: 'Rekapitulasi Penggunaan BMD',
        value: 'penggunaan-bmd',
      },
      {
        text: 'Rekapitulasi Potensi Pemanfaatan',
        value: 'potensi-pemanfaatan',
      },
      {
        text: 'Rekapitulasi Nilai Strategis BMD',
        value: 'nilai-strategis-bmd',
      },
      {
        text: 'Rekapitulasi Pengamanan Fisik',
        value: 'pengamanan-fisik',
      },
      {
        text: 'Rekapitulasi Sengketa',
        value: 'sengketa',
      },
      {
        text: 'Rekapitulasi BMD Belum Tercatat',
        value: 'bmd-belum-tercatat',
      },
      {
        text: 'Rekapitulasi BMD Bersejarah',
        value: 'aset-bersejarah',
      },
    ])

    const clickPdf = async () => {
      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/laporan/${jenisLaporanFilter.value}?filter_kib=${kibFilter.value}&filter_tahun=${tahunFilter.value}&filter_upd=${pdUpdFilter.value}&format=pdf`,
        '_blank',
      )
    }

    const clickExcel = async () => {
      window.open(
        `https://jakaset.jakarta.go.id/${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/laporan/${jenisLaporanFilter.value}?filter_kib=${kibFilter.value}&filter_tahun=${tahunFilter.value}&filter_upd=${pdUpdFilter.value}&format=excel`,
        '_blank',
      )
    }

    const getKib = async () => {
      const resKib = await master.getKib(g)
      resKib.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataKib.value = resKib
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    getWilayah()

    const getPdUpd = async (searchPdUpd = '') => {
      const params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      }
      const resPdUpd = await master.getPdUpd(g, params)
      resPdUpd.unshift({ text: '-- Pilih Salah Satu --', value: '' })
      dataPdUpd.value = resPdUpd
    }

    getKib()
    getPdUpd()

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = ''
        pdUpdFilterValue.value = { text: '-- Pilih Salah Satu --', value: '' }
      }
      getPdUpd()
    }

    const searchPdUpd = async search => {
      getPdUpd(search)
    }

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value) { pdUpdFilter.value = pdUpdFilterValue.value.value }
    }

    const momentFormat = tanggal => {
      const tempTanggal = moment(tanggal).format('DD-MM-YYYY HH:mm:ss')
      return tempTanggal == 'Invalid date' ? '' : tempTanggal
    }

    const downloadFile2 = file => {
      window.open(file)
    }

    return {
      isLoadingUpload,
      tahunFilter,
      pdUpdFilter,
      kibFilter,
      wilayahFilter,
      pdUpdFilterValue,
      ukuranFilter,
      filePdf,
      versiFilter,
      jenisLaporanFilter,

      dataTahun,
      dataWilayah,
      dataPdUpd,
      dataProvinsi,
      dataKecamatan,
      dataKelurahan,
      dataKib,
      dataUkuran,
      dataVersi,
      dataJenisLaporanFilter,

      clickPdf,
      clickExcel,
      changeWilayah,
      searchPdUpd,
      inputPdUpd,
      momentFormat,
      downloadFile2,
    }
  },
  components: {
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
    BIcon,
  },
  directives: {
    Ripple,
  },
  props: {
    page: { type: String, default: '' },
  },
  data() {
    return {
      columns: [
        {
          label: 'Nama Lokasi',
          field: 'kolok',
        },
        {
          label: 'Tanggal',
          field: 'updated_date',
        },
        {
          label: 'File',
          field: 'file',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
.pdfobject-container {
  height: 80rem;
  border: 1rem solid rgba(0, 0, 0, 0.1);
}
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
